import { render } from "./HeroAccordion.vue?vue&type=template&id=39402c81"
import script from "./HeroAccordion.vue?vue&type=script&lang=js"
export * from "./HeroAccordion.vue?vue&type=script&lang=js"

import "./HeroAccordion.vue?vue&type=style&index=0&id=39402c81&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__